import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
const req = require.context('./modules', false, /\.ts$/)
const requireAll = (requireContext: any) => {
  const modules: any = {}
  requireContext.keys().forEach((path: any) => {
    const reg = /^\S+\/(\w+)\.ts$/
    const fileName = path.match(reg)[1] // 文件名需已驼峰格式 其它格式需转为驼峰（未处理）
    modules[fileName] = requireContext(path).default
  })
  return modules
}
const modules = requireAll(req)

export default createStore({
  modules,
  plugins: [
    createPersistedState({
      storage: window.sessionStorage, // 或者 localStorage
      reducer(state) {
        let stateCopy = state as object
        return stateCopy
      },
    }),
  ],
})
